import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { apiOrderPage } from '@/service/api/orderPage';
import type { OrderResponse } from '@/service/api/orderPage';
import { OrderStatusEnum, PlatformEnum } from '@/service/api/types';

export default () => {
  const { t } = useTranslation();
  const [activeStatus, setActiveStatus] = useState<OrderStatusEnum>(OrderStatusEnum.ALL);
  const [activeKey, setActiveKey] = useState<PlatformEnum>(PlatformEnum.ALL);
  const [orders, setOrders] = useState<OrderResponse['orderDetails']>([]);
  const [loading, setLoading] = useState(false);
  const controllerRef = useRef<AbortController>(new AbortController());
  const [keyword, setKeyword] = useState<string>('');
  const currentPage = useRef(1);
  const keywordRef = useRef<string>('');
  const [pagination, setPagination] = useState<OrderResponse['pagination']>({
    hasMore: true,
    nextCursor: undefined,
  })
  const nextCursorMapRef = useRef<Record<string, any>>({})

  useEffect(() => {
    nextCursorMapRef.current = {}
    currentPage.current = 1;
    fetchOrders();
  }, [activeStatus, activeKey])

  const fetchOrders = async () => {
    controllerRef.current.abort();
    controllerRef.current = new AbortController();
    setLoading(true);
    try {
      const res = await apiOrderPage({
        status: activeStatus,
        platform: activeKey,
        keyword: keywordRef.current,
        limit: 6,
        cursor: nextCursorMapRef.current[currentPage.current],
      }, {
        signal: controllerRef.current.signal,
      })
      if (res.code === 0) {
        setOrders(res.data.orderDetails);
        setPagination(res.data.pagination);
        nextCursorMapRef.current[currentPage.current + 1] = res.data.pagination?.nextCursor;
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
   
  }

  const onNextPage = () => {
    currentPage.current++;
    fetchOrders();
  }

  const onPreviousPage = () => {
    currentPage.current--;
    fetchOrders();
  }

  const handSearch = () => {
    currentPage.current = 1;
    keywordRef.current = keyword;
    nextCursorMapRef.current = {}
    fetchOrders();
  }

  return {
    activeStatus,
    setActiveStatus,
    activeKey,
    setActiveKey,
    orders,
    loading,
    pagination,
    keyword,
    currentPage: currentPage.current,
    setKeyword,
    handSearch,
    onNextPage,
    onPreviousPage,
  }
}